module.exports = __webpack_public_path__ + "img/icon-6.b44655dc.png";